import { z } from 'zod';

export const MediaKindSchema = z.enum(['image','video']);

export type MediaKindType = `${z.infer<typeof MediaKindSchema>}`

export default MediaKindSchema;
